var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['message-hint', _vm.value.isTime ? 'message-hint-time' : 'message-hint-normal']},[_vm._v(" "+_vm._s(_vm.value.isTime ? _vm.formatTime(_vm.value.text) : _vm.value.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }